var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box8-page"},[_c('img',{attrs:{"src":require("../../../assets/coursePage/inseec/box8/footer-qrcode.png"),"alt":""}})])}]

export { render, staticRenderFns }